export const FORUM_ENTRY_MAX_LENGTH = 255
